(() => {
  const normalize = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

  const selectedColor = (root) => {
    const checked = [...root.querySelectorAll('variant-selects input[type="radio"]:checked')]
      .find((input) => {
        const optionName = input.dataset.optionName || String(input.name || '').replace(/-\d+$/, '');
        return /^(color|colour|颜色)$/i.test(optionName);
      });
    return normalize(checked?.value);
  };

  const colorAliases = (color) => {
    if (color === 'forest-green') return ['forest-green', 'dark-green'];
    if (color === 'dark-green') return ['dark-green', 'forest-green'];
    return [color];
  };

  const filterMedia = (root) => {
    const color = selectedColor(root);
    const media = [...root.querySelectorAll('[data-mimi-collar-color]')];
    if (!media.length || !color) return;

    const acceptedColors = colorAliases(color);
    const matchingMedia = media.filter((item) => acceptedColors.includes(item.dataset.mimiCollarColor));
    if (!matchingMedia.length) {
      media.forEach((item) => {
        item.hidden = false;
      });
      return;
    }

    media.forEach((item) => {
      item.hidden = !acceptedColors.includes(item.dataset.mimiCollarColor);
    });

    const current = root.querySelector('.thumbnail[aria-current="true"]');
    if (current?.closest('[data-mimi-collar-color]')?.hidden) {
      matchingMedia
        .find((item) => item.classList.contains('thumbnail-list__item'))
        ?.querySelector('.thumbnail')
        ?.click();
    }
  };

  const init = () => {
    document.querySelectorAll('.product-info--solid-collar').forEach((root) => {
      filterMedia(root);
      root.addEventListener('change', (event) => {
        if (event.target.matches('variant-selects input[type="radio"]')) {
          requestAnimationFrame(() => filterMedia(root));
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
